import DatePicker from "react-datepicker";
import Navbar from "../navbar/navbar";
import { useEffect, useState } from "react";
import Datatable from "../../datatable/Datatable";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import AlertConfirmation from "../../common/AlertConfirmation.component";
import { createEkadasi, deleteEkadasi, getEkadasiById, getEkadasiMasterList, updateEkadasi } from "../../services/admin.service";
import { FaEdit, FaTrash } from "react-icons/fa";
import "../admin/adminModule.css";

const EkadasiMasterListComponent = () => {

    const currentYear = new Date().getFullYear();
    const startOfYear = new Date(currentYear, 0, 1);
    const endOfYear = new Date(currentYear, 11, 31);
    const [fromDate, setFromDate] = useState(startOfYear);
    const [toDate, setToDate] = useState(endOfYear);
    const [ekadasiMasterList, setEkadasiMasterList] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editData, setEditData] = useState(null);
    const loginId = Number(localStorage.getItem('loginId'));

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const getMinDate = () => {
        const currentDate = new Date();
        const minYear = currentDate.getFullYear() - 20;
        return new Date(minYear, currentDate.getMonth(), currentDate.getDate());
    };
    const getMaxDate = () => {
        const currentDate = new Date();
        const maxYear = currentDate.getFullYear() + 50;
        return new Date(maxYear, currentDate.getMonth(), currentDate.getDate());
    };

    useEffect(() => {
        fetchEkadasiMasterList(fromDate, toDate);
    }, [fromDate, toDate]);

    const fetchEkadasiMasterList = async (from, to) => {
        try {
            const fromDate = formatDate(from);
            const toDate = formatDate(to);
            const response = await getEkadasiMasterList(fromDate, toDate);
            if (response) {
                setEkadasiMasterList(response);
            } else {
                setEkadasiMasterList([]);
            }
        } catch (error) {
            console.error('Error fetching Ekadasi Master List:', error);
        }
    };

    const validationSchema = Yup.object({
        ekadasiRemarks: Yup.string().required("Ekadasi remarks is required"),
        ekadasiDate: Yup.date().required("Ekadasi Date is required")
    });

    const initialValues = {
        ekadasiRemarks: editData?.ekadasiRemarks || "",
        ekadasiDate: editData?.ekadasiDate || new Date(),
    };

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Ekadasi Date", selector: (row) => row.ekadasiDate, sortable: true, align: 'text-start' },
        { name: "Ekadasi Remarks", selector: (row) => row.ekadasiRemarks, sortable: true, align: 'text-start' },
        { name: "Action", selector: (row) => row.action, sortable: true, align: 'text-center' },
    ];


    const mappedData = () => {
        return ekadasiMasterList.map((item, index) => ({
            sn: index + 1,
            ekadasiDate: item.ekadasiDate ? new Date(item.ekadasiDate).toLocaleDateString('en-GB').replace(/\//g, '-') : '-',
            ekadasiRemarks: item.ekadasiRemarks || '-',
            action: (
                <>
                    <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => { handleEdit(item) }}
                        title="Edit Ekadasi"
                    >
                        <FaEdit />
                    </button>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => { handleDelete(item) }}
                        title="Delete Ekadasi"
                    >
                        <FaTrash />
                    </button>
                </>
            )
        }))
    }

    const handleAddEkadasi = () => {
        setEditMode(false);
        setEditData(null);
        setOpenModal(true);
    };

    const handleEdit = async (item) => {
        setEditMode(true);
        const response = await getEkadasiById(item.ekadasiId);
        if (response) {
            setEditData(response);
            setOpenModal(true);
        } else {
            Swal.fire("Error", "Failed to fetch Ekadasi details", "error");
        }
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const isEdit = !!editData;
            const payload = {
                ekadasiRemarks: values.ekadasiRemarks,
                ekadasiDate: values.ekadasiDate ? values.ekadasiDate : null,
                ekadasiType: 'E',
                isActive: 1,
                ...(isEdit
                    ? {
                        ekadasiId: editData.ekadasiId,
                        modifiedBy: loginId,
                        // modifiedDate: new Date().toISOString().split("T")[0],
                        modifiedDate: new Date().toISOString(),
                    }
                    : {
                        createdBy: loginId,
                        createdDate: new Date().toISOString(),
                    })

            };
            if (editData) {
                // EDIT
                const confirm = await AlertConfirmation({ title: "Are you sure to update!", message: '' });
                if (!confirm) return;
                const result = await updateEkadasi(editData?.ekadasiId, payload);
                if (result) {
                    Swal.fire("Updated", "Ekadasi updated successfully", "success");
                    fetchEkadasiMasterList(fromDate, toDate);
                } else {
                    Swal.fire("Error", "Failed to update ekadasi", "error");
                }
            } else {
                // ADD
                const confirm = await AlertConfirmation({ title: "Are you sure to add!", message: '' });
                if (!confirm) return;
                const result = await createEkadasi(payload);
                if (result) {
                    Swal.fire("Added", "Ekadasi created successfully", "success");
                    fetchEkadasiMasterList(fromDate, toDate);
                } else {
                    Swal.fire("Error", "Failed to create ekadasi", "error");
                }
            }
            resetForm();
            setOpenModal(false);
            setEditMode(false);
            setEditData(null);
        } catch (error) {
            Swal.fire("Error", "Something went wrong", "error");
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (item) => {
        if (!item.ekadasiId) {
            Swal.fire("Error", "Failed to Delete Ekadasi", "error");
            return;
        }
        const confirm = await AlertConfirmation({ title: "Are you sure to delete!", message: '' });
        if (!confirm) return;
        const result = await deleteEkadasi(item.ekadasiId);
        if (result) {
            Swal.fire("Deleted", "Ekadasi deleted successfully", "success");
            fetchEkadasiMasterList(fromDate, toDate);
        } else {
            Swal.fire("Error", "Failed to delete ekadasi", "error");
        }
    };


    return (
        <div className="card">
            <Navbar />
            <div className="card-body">
                <div className="col-md-12 text-center">
                    <h3 className="admin-custom-heading">Ekadasi Master List</h3>
                </div>
            </div>
            <div className="d-flex justify-content-end rowHeadercolor">
                <div className="col-md-2 d-flex align-items-center">
                    <label className="font-label me-2 mb-0">From :</label>
                    <DatePicker
                        selected={fromDate}
                        onChange={(newValue) => {
                            setFromDate(newValue);
                        }}
                        className="form-control"
                        placeholderText="From Date"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                        onKeyDown={(event) => event.preventDefault()}
                    />
                </div>

                <div className="col-md-2 d-flex align-items-center">
                    <label className="font-label me-2 mb-0">To :</label>
                    <DatePicker
                        selected={toDate}
                        onChange={(newValue) => {
                            setToDate(newValue);
                        }}
                        className="form-control"
                        placeholderText="To Date"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                        onKeyDown={(event) => event.preventDefault()}
                    />
                </div>
            </div>
            <div id="card-body customized-card" className="p-2">
                {<Datatable columns={columns} data={mappedData()} />}
            </div>
            <div className="text-center mb-3">
                <button type="submit" className="add" onClick={handleAddEkadasi}>
                    Add New
                </button>
            </div>

            {openModal && (
                <div className="modal show d-block cs-modal-bg" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header bg-warning">
                                <h5 className="modal-title">{editMode ? "Edit Ekadasi" : "Add Ekadasi"}</h5>
                                <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <Formik
                                    enableReinitialize
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ setFieldValue, values }) => (
                                        <Form>
                                            <div className="row g-3 align-items-center">
                                                <div className="col-md-6">
                                                    <label className="form-label">Ekadasi Remarks</label>
                                                    <Field type="text" name="ekadasiRemarks" className="form-control" />
                                                    <ErrorMessage name="ekadasiRemarks" component="div" className="text-danger small" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label">Ekadasi Date</label>
                                                    <DatePicker
                                                        id="ekadasiDate"
                                                        name="ekadasiDate"
                                                        selected={values.ekadasiDate}
                                                        onChange={(date) => setFieldValue("ekadasiDate", date)}
                                                        className="form-control my-1"
                                                        placeholderText="ekadasiDate Date"
                                                        dateFormat="dd-MM-yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"
                                                        minDate={getMinDate()}
                                                        maxDate={getMaxDate()}
                                                        onKeyDown={(event) => event.preventDefault()}
                                                    />
                                                    <ErrorMessage name="ekadasiDate" component="div" className="text-danger small" />
                                                </div>
                                            </div>
                                            <div className="text-center mt-4">
                                                <button type="submit" className="submit me-2">{editMode ? `Update` : `Submit`}</button>
                                                <button type="button" className="back" onClick={() => setOpenModal(false)}>Cancel</button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
};

export default EkadasiMasterListComponent;